import Image from "next/image"
import { useContext, useEffect } from "react"
import { isMobileContext } from "../../contexts/isMobileContext"
import { AnimatePresence, motion } from "framer-motion";
import { BASE_URL } from "../../utils/FetchData"
import FadeIn from "../Animations/FadeIn";

const AboutCard = ({ header, index, isActive, slides, prevSlide,setCanClick }) => {
    const { isMobile } = useContext(isMobileContext)
    return (
        <div className={`about-card
        ${slides == index ? "active" : ""} 
		${prevSlide == index ? "prev" : ""}
        `}>
            <div className="left-container">
                {isMobile && <span >{header?.Headline}</span>}
                <div className={`card-image`}>
                    <div className="img-container">
                        {header?.Small_Img_Desktop?.data?.attributes?.url &&
                            isMobile ? <Image
                            src={BASE_URL + header?.Small_Img_Mobile?.data?.attributes?.url}
                            alt="image"
                            layout="fill"
                            objectFit="cover"
                            priority
                        />
                            :
                            <Image
                                src={BASE_URL + header?.Small_Img_Desktop?.data?.attributes?.url}
                                alt="image"
                                layout="fill"
                                objectFit="cover"
                                priority
                            />
                        }
                    </div>
                    {isMobile && <div className="small-img-container">
                        {header?.Big_Img_Mobile?.data?.attributes?.url && <Image
                            src={BASE_URL + header?.Big_Img_Mobile?.data?.attributes?.url}
                            alt="image"
                            layout="fill"
                            objectFit="cover"
                            priority
                        />}
                    </div>}
                </div>
                <FadeIn customClass={`card-data`} slideNumber={slides} setCanClick={setCanClick}>
                    {!isMobile && <span className="_eleX">{header?.Headline}</span>}
                    <h3 className="light _eleX">{header?.Title}</h3>
                    <p className="_eleX">{header?.Description}</p>
                </FadeIn>
            </div>
            <div className="right-container">
                <div className="img-container">
                    {header?.Big_Img_Desktop?.data?.attributes?.url && <Image
                        src={BASE_URL + (isMobile ? header?.Big_Img_Mobile?.data?.attributes?.url : header?.Big_Img_Desktop?.data?.attributes?.url)}
                        alt="image"
                        layout="fill"
                        objectFit="cover"
                        priority
                    // objectPosition={"bottom"}
                    />}
                </div>
            </div>
        </div>
    )
}

export default AboutCard